import React, {Component} from 'react'
import {Icon, Row} from 'rsuite'

import {StyledButton, StyledQuestionaryInfoCard} from '../styled/StyledQuestionComponents'
import ModalConfirmStartQuestionary from './ModalConfirmStartQuestionary'


class DefautQuestionaryInfoCard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showConfirmModal: false,
        }
        this.closeConfirmModal = this.closeConfirmModal.bind(this)
        this.confirmStartQuestionary = this.confirmStartQuestionary.bind(this)
    }

   componentDidUpdate(prevProps){
        const {previousTriesDTO} = this.props
        previousTriesDTO &&
            prevProps.previousTriesDTO !== previousTriesDTO &&
                this.props.loading()
    }

    confirmStartQuestionary() {
        this.setState({showConfirmModal: true})
    }

    closeConfirmModal() {
        this.setState({showConfirmModal: false})
    }

    render() {

        const {title, timeLimit, numQuestions, maxTries} = this.props.questionaryInfo
        const previousTriesDTO = this.props.previousTriesDTO
        const totalInfo = numQuestions < 2 ? `${numQuestions}` + ' questão' : `${numQuestions}` + ' questões'

        const tries = previousTriesDTO && maxTries && maxTries - previousTriesDTO.length
        const infoTries = tries === 1 ? `${tries}` + ' tentativa restante' : `${tries}` + ' tentativas restantes'
        const disabled = maxTries ? tries <= 0 : false

        return (
            <div>
                <Row>
                    <StyledQuestionaryInfoCard>
                        <div className={'description-col'}>
                            <h1>Simulado: <span> {title} </span></h1>
                            <div className={'description-text'}>
                                <p>Este simulado é composto por {totalInfo}.<br/>
                                    {
                                        !!timeLimit ?
                                            <span>E possui {timeLimit} minutos de duração, acompanhando o mesmo modelo do exame oficial.</span> :
                                            <span>Acompanhando o mesmo modelo do exame oficial.</span>
                                    }
                                </p>
                            </div>
                            {
                              
                                    <StyledButton
                                        color={'green'}
                                        appearance="defaut"
                                        disabled={disabled}
                                        onClick={() => this.confirmStartQuestionary()}
                                    >
                                        Iniciar simulado
                                        {
                                            !disabled && tries ?
                                                ` (${infoTries})` :
                                                ''
                                        }
                                        <Icon icon='long-arrow-right' size="lg"/>
                                    </StyledButton>
                            }
                        </div>
                        <div className={'info ' + (!timeLimit && 'no-time')}>
                            <div className={'questions-info'}>
                                <span>{numQuestions}</span> <br/> questões
                            </div>
                            {
                                !!timeLimit &&
                                <div className={'duration-info'}>
                                    <span>{timeLimit}</span>m <br/> duração
                                </div>
                            }
                        </div>
                    </StyledQuestionaryInfoCard>

                </Row>
                <ModalConfirmStartQuestionary
                    showConfirmModal={this.state.showConfirmModal}
                    closeConfirmModal={this.closeConfirmModal}
                    startQuestionary={this.props.startQuestionary}
                    hasTimeLimit={!!timeLimit}
                />
            </div>

        )

    }
}

export default DefautQuestionaryInfoCard





// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/DefautQuestionaryInfoCard.js